module.exports = __webpack_public_path__ + "static/media/Whisperwood-Bylaws-1.5724222b.pdf";